import { Dropdown, Button, Spacer, Icon, CaretSvg, Body, colors } from '@spritz-finance/ui'
import { useState, useMemo } from 'react'
import styled from 'styled-components'
import { Row } from '../../../../components/Layout/Row'
import { FullPaymentFragment, PaymentStatus } from '../../../../graphql/generated/graphql'
import { toTitleCase } from '../../../../utils/string'

type Payment = FullPaymentFragment

const ButtonContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const usePaymentStatusFilter = (payments: Payment[]) => {
    const [statusFilter, setStatusFilter] = useState<PaymentStatus | null>(null)

    const statusOptions = useMemo(
        () =>
            payments.reduce((statuses, payment) => {
                const status = payment.status
                if (!statuses.includes(status)) {
                    statuses.push(status)
                }
                return statuses
            }, [] as PaymentStatus[]),
        [payments]
    )

    const filteredPayments = useMemo(() => {
        if (!statusFilter) return payments
        return payments.filter((payment) => payment.status === statusFilter)
    }, [statusFilter, payments])

    return { statusOptions, setStatusFilter, filteredPayments, statusFilter }
}

export const PaymentStatusFilter = ({
    options,
    setStatusFilter,
}: {
    options: PaymentStatus[]
    setStatusFilter: React.Dispatch<React.SetStateAction<PaymentStatus | null>>
}) => {
    return (
        <Dropdown.Menu
            minWidth={160}
            align="end"
            anchor={
                <Button.Text>
                    <ButtonContent>
                        Filter by <Spacer width={4} />
                        <Icon icon={CaretSvg} />
                    </ButtonContent>
                </Button.Text>
            }
        >
            {options.map((option, index) => {
                return (
                    <Dropdown.Item
                        onClick={() =>
                            setStatusFilter((current) => (current === option ? null : option))
                        }
                        key={index}
                    >
                        <Row align="space-between">
                            <Body.Med size={14} secondary>
                                {toTitleCase(option)}
                            </Body.Med>
                        </Row>
                    </Dropdown.Item>
                )
            })}
        </Dropdown.Menu>
    )
}
